import React from "react";
import { PlayCircle } from "lucide-react";
import { fetchVideoUrl } from "@Http/gcp_signer_urls";

import styles from "./VideoPlayer.module.scss";
const VideoPlayer = ({ publicUrl }: { publicUrl: string }) => {
  const [videoUrl, setVideoUrl] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchUrl = async () => {
      const url = await fetchVideoUrl(publicUrl);
      setVideoUrl(url);
    };

    fetchUrl();
  }, [publicUrl]);

  return (
    <div className="video-container">
      {videoUrl ? (
        <video width="100%" controls>
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div className={styles.videoPlaceholder}>
          <PlayCircle size={48} />
          <p>Loading video...</p>
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
